export const IMAGE_PATH_60 = `${process.env.PUBLIC_URL}/assets/img/w60/`;
export const IMAGE_PATH_350 = `${process.env.PUBLIC_URL}/assets/img/w350/`;
export const IMAGE_PATH_1000 = `${process.env.PUBLIC_URL}/assets/img/w1000/`;



// WEBPACK FOOTER //
// ./src/data/constants.js